export default __webpack_public_path__ + "static/media/Esther Maria1.fd185bc9.jpeg";